"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BGImageBox = exports.TEST_ID_IMAGE_BOX = void 0;
var theme_ui_1 = require("theme-ui");
var colors_1 = require("../../../theme/colors");
exports.TEST_ID_IMAGE_BOX = "BGImageBox";
var BGImageBox = function (_a) {
    var img = _a.img, gradient = _a.gradient, children = _a.children, _b = _a.csx, csx = _b === void 0 ? {} : _b;
    return (theme_ui_1.jsx(theme_ui_1.Box, { sx: __assign({ height: "100%", width: "100%", background: gradient
                ? colors_1.gradients[gradient] + ", url(" + img + ")"
                : "url(" + img + ")", backgroundSize: "cover", backgroundRepeat: "no-repeat" }, csx), "data-testid": exports.TEST_ID_IMAGE_BOX }, children));
};
exports.BGImageBox = BGImageBox;
